import { render, staticRenderFns } from "./impactFactors.vue?vue&type=template&id=79e21303&scoped=true&"
import script from "./impactFactors.vue?vue&type=script&lang=js&"
export * from "./impactFactors.vue?vue&type=script&lang=js&"
import style0 from "./impactFactors.vue?vue&type=style&index=0&id=79e21303&prod&lang=stylus&scoped=true&"
import style1 from "./impactFactors.vue?vue&type=style&index=1&id=79e21303&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e21303",
  null
  
)

export default component.exports